import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuestAuthResolver implements Resolve<any> {
  constructor(private http: HttpClient) {}

  resolve(): Observable<any> {
    console.log('GuestAuthResolver triggered');
    let uuid = localStorage.getItem('uuid');
    if (!uuid) {
      uuid = crypto.randomUUID();
    }
    return this.http.post(`${environment.apiUrlTemp}/app/auth/public/webagent/register`, { uuid }).pipe(
      tap((response: any) => {
        if (response?.authorisation?.token) {
          localStorage.setItem('token', response?.authorisation?.token);
          localStorage.setItem('uuid', uuid);
        }
      })
    );
  }
}